import { Button } from 'antd-mobile';
import s from './style.module.scss';
const GrtButton = (props) => {
    const { children, ...otherProps } = props;
    return (
        <span className={s['grt-button']}>
            <Button {...otherProps}>{children}</Button>
        </span>
    );
};
export default GrtButton;
